import React from 'react'



const Seperator=({amount})=>{
    return(
        <pre style={{marginLeft:amount+"px"}}></pre>
    )
}




export default Seperator